import { render, staticRenderFns } from "./RestrictedBlendsList.vue?vue&type=template&id=ba5a6790&"
import script from "./RestrictedBlendsList.vue?vue&type=script&lang=js&"
export * from "./RestrictedBlendsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports